const Swal = require("sweetalert2/dist/sweetalert2.js");

$(".sweetalert").click(function (e) {
    e.preventDefault()
    e.stopPropagation()

    Swal.fire({
        title: "¿Estás seguro?",
        text: 'Esta acción no se puede revertir.',
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí, Eliminar",
        cancelButtonText: "No, Cancelar",
        reverseButtons: true,
    }).then(function (result) {
        if (result.value) {
            Swal.fire("¡Eliminado!", "El recurso ha sido eliminado.", "success");

            if (e.currentTarget.tagName === "FORM") {
                setTimeout(() => {
                    e.currentTarget.submit();
                }, 400);
            }

            if(e.currentTarget.getAttribute('form')) {
                document.getElementById(e.currentTarget.getAttribute("form")).submit();
            }
        }
    });
});
